
import { Component, EventEmitter, inject, Output, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ToolkitApiService, RadioNode, RadiosComponent } from '@jeppesen-foreflight/jmkw-toolkit';
import { ExtendedMap } from '@jeppesen-foreflight/jmkw-types';
import { switchMap, of } from 'rxjs';
import { NavigationLayer } from '../../../layer/navigation.layer';
import {
  Persona,
  DEFAULT_PERSONA,
  PERSONA_ARRAY
} from '../../../../../../types/persona.model';

@Component({
  selector: 'jmkw-ui-personas-popout',
  standalone: true,
  imports: [RadiosComponent],
  templateUrl: './personas-popout.component.html',
  styleUrl: './personas-popout.component.scss'
})
export class PersonasPopoutComponent {
  private readonly _api = inject(ToolkitApiService);

  @Output() selection = new EventEmitter<Persona>();

  currentPersona: Signal<Persona> = toSignal(
    this._api
      .onLayerReady$<NavigationLayer>('navigation')
      .pipe(switchMap((layer) => layer?.persona$ ?? of(DEFAULT_PERSONA))),
    { initialValue: DEFAULT_PERSONA }
  );

  radioNodeMap = this.createRadioNodeMapFromPersonas();

  private createRadioNodeMapFromPersonas(): ExtendedMap<RadioNode> {
    return PERSONA_ARRAY.reduce((radioMap, persona) => {
      radioMap.set(
        persona,
        new RadioNode({
          id: persona,
          label: persona,
          onChange: (id: string) => {
            const persona = id as Persona;
            this.handlePersonaChange(persona);
            this.selection.emit(persona);
          }
        })
      );
      return radioMap;
    }, new ExtendedMap<RadioNode>());
  }

  private handlePersonaChange(persona: Persona): void {
    const layer = this._api.getLayerById('navigation') as NavigationLayer;
    layer?.jepTools?.togglePersona?.(persona);
  }
}
